import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50fbe5a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cardBlocks" }
const _hoisted_2 = {
  key: 0,
  class: "text-center mt-4"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "fs-22 fs_white"
}
const _hoisted_6 = { class: "cardContainer" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "text-left" }
const _hoisted_10 = {
  ref: "cardnumber",
  class: "payInput mb-1"
}
const _hoisted_11 = { class: "text-left mt-2" }
const _hoisted_12 = {
  ref: "cardexpiry",
  class: "payInput mb-1"
}
const _hoisted_13 = { class: "text-left mt-2" }
const _hoisted_14 = {
  ref: "cardcvc",
  class: "payInput mb-1"
}
const _hoisted_15 = {
  ref: "carderrors",
  class: "mt-2 text-danger",
  role: "alert"
}
const _hoisted_16 = {
  key: 0,
  class: "form-group d-flex justify-content-center align-items-center mt-3 w-100"
}
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any) {
  const _component_mini_spinner = _resolveComponent("mini-spinner")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_stripe_saved_cards = _resolveComponent("stripe-saved-cards")!
  const _component_toggler = _resolveComponent("toggler")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.anonymous)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.cards)
            ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.cards && _ctx.cards.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["cardBlock", { active: _ctx.showNewCard }]),
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setShowNewCard && _ctx.setShowNewCard(...args)))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Nuova carta di credito",
                      text: "Nuova carta di credito"
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["cardBlock", { active: !_ctx.showNewCard }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showNewCard = false))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Carte di credito salvate",
                      text: "Carte di credito salvate"
                    })
                  ], 2)
                ]),
                (_ctx.cards.length > 0 && !_ctx.showNewCard)
                  ? (_openBlock(), _createBlock(_component_stripe_saved_cards, {
                      key: 0,
                      cards: _ctx.cards,
                      modelValue: _ctx.selectedCard,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCard) = $event))
                    }, null, 8, ["cards", "modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.paying)
                  ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 1 }))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (_ctx.selectedCard)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-primary fs-22",
                              disabled: !!!_ctx.selectedCard,
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.pay && _ctx.pay(...args)))
                            }, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Paga",
                                text: "Paga"
                              })
                            ], 8, _hoisted_3)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.cards && _ctx.cards.length == 0 || _ctx.showNewCard && !!!_ctx.selectedCard)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("form", {
            class: "paymentForm",
            ref: "paymentform",
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.pay && _ctx.pay(...args)), ["prevent"]))
          }, [
            (_ctx.isTestMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Pagamento in modalità test, inserire 4242 4242 4242 4242 come numero carta. <br/> Per gli altri campi va bene qualunque dato.",
                    text: "Pagamento in modalità test, inserire 4242 4242 4242 4242 come numero carta. <br/> Per gli altri campi va bene qualunque dato."
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_localized_text, {
                  type: "label",
                  localizedKey: "Intestatario carta",
                  text: "Intestatario carta"
                }),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control payInput mb-1",
                  placeholder: _ctx.placeholder1,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cardholderName) = $event))
                }, null, 8, _hoisted_8), [
                  [_vModelText, _ctx.cardholderName]
                ])
              ]),
              _createElementVNode("label", _hoisted_9, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Numero carta",
                  text: "Numero carta"
                })
              ]),
              _createElementVNode("div", _hoisted_10, null, 512),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_11, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Scadenza carta",
                    text: "Scadenza carta"
                  })
                ]),
                _createElementVNode("div", _hoisted_12, null, 512),
                _createElementVNode("label", _hoisted_13, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Codice di sicurezza (cvc)",
                    text: "Codice di sicurezza (cvc)"
                  })
                ]),
                _createElementVNode("div", _hoisted_14, null, 512)
              ]),
              _createElementVNode("div", _hoisted_15, null, 512)
            ]),
            (_ctx.paying)
              ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 1 }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (!_ctx.anonymous && !_ctx.isTestMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Salva carta per i pagamenti futuri",
                            text: "Salva carta per i pagamenti futuri"
                          })
                        ]),
                        _createVNode(_component_toggler, {
                          class: "ms-2",
                          modelValue: _ctx.saveCard,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.saveCard) = $event))
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("button", {
                      ref: "submit",
                      type: "submit",
                      class: "btn btn-primary fs-22 mt-2",
                      disabled: !_ctx.canPay
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Paga",
                        text: "Paga"
                      })
                    ], 8, _hoisted_18)
                  ])
                ], 64))
          ], 544)
        ]))
      : _createCommentVNode("", true)
  ]))
}